import { useSearchParams } from "react-router-dom";
import DatabookBuilderEngine from "./databook-builder/DatabookBuilderEngine";
import DatabookBuilderLegacyEngine from "./databook-builder/DatabookBuilderLegacyEngine";
import { getDatabookBuilderMode } from "./databook-builder/databookBuilderMode";
import { builderStageFromQuery } from "./databook-builder/builderStages";

const DEMO_MODE = import.meta.env?.VITE_DEMO_MODE === "true";

/**
 * Databook Builder page.
 * Mounts the connected project builder or the standalone demo.
 */
export default function DatabookBuilder() {
  const [searchParams] = useSearchParams();
  const projectId: string | undefined = searchParams.get("projectId") ?? undefined;
  const initialStage = builderStageFromQuery(searchParams.get("stage"));

  if (getDatabookBuilderMode(DEMO_MODE) === "demo") {
    return <DatabookBuilderLegacyEngine />;
  }

  return (
    <DatabookBuilderEngine
      key={`${projectId ?? "no-project"}:${initialStage ?? "saved"}`}
      projectId={projectId}
      initialStage={initialStage ?? undefined}
    />
  );
}
